import { NavLink, useNavigate } from "react-router-dom";
import { api, setToken } from "../lib/api";
import type { ReactNode } from "react";

const nav = [
  { to: "/", label: "Dashboard" },
  { to: "/regions", label: "Regions" },
  { to: "/producers", label: "Producers" },
  { to: "/bottles", label: "Bottles" },
  { to: "/tasting-notes", label: "Tasting Notes" },
];

export default function Shell({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  async function signOut() {
    try {
      await api.auth.signOut();
    } finally {
      // Clear the token even if the request failed: the user asked to be
      // signed out, and leaving a working token because the network blipped is
      // the wrong side to fail on.
      setToken(null);
      navigate("/signin");
    }
  }

  return (
    <div className="flex min-h-full">
      <aside className="hidden w-56 shrink-0 border-r border-hairline p-4 sm:block">
        <div className="mb-6 px-2">
          <p className="text-sm font-semibold">Cellar Book</p>
          <p className="text-xs text-muted">Track every bottle in the restaurant cellar</p>
        </div>
        <nav className="flex flex-col gap-1">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              className={({ isActive }) =>
                `rounded-card px-3 py-2 text-sm ${
                  isActive ? "bg-brand text-white" : "text-muted hover:bg-hairline/40"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <button
          onClick={signOut}
          className="mt-6 w-full rounded-card px-3 py-2 text-left text-sm text-muted hover:bg-hairline/40"
        >
          Sign out
        </button>
      </aside>
      <main className="min-w-0 flex-1 p-6">{children}</main>
    </div>
  );
}
